exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpick-wrapper label{font-size:1rem;margin-bottom:5px;color:#222}.flatpick-wrapper input.date-picker-input{display:block;width:100%;height:calc(1.6em + .75rem + 4px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.6;color:#495057;background-color:#f7f7f7}.flatpick-wrapper input.date-picker-input:focus{border:none;outline:none;box-shadow:0 0 5px 0 #2564f5}", ""]);

// exports
